import type { MaterializedMenuProduct } from '@iheartjane/data-access';
import type { PriceId } from '@iheartjane/types';
import compact from 'lodash-es/compact';

import type { AlgoliaProduct } from '@jane/search/data-access';
import { formatPotency, getPotencyInfo } from '@jane/shared-ecomm/util';
import type { MenuProduct } from '@jane/shared/types';

export const potencyDescription = (
  product: MenuProduct | AlgoliaProduct | MaterializedMenuProduct,
  selectedWeight?: PriceId
) => {
  const {
    productAmount,
    dosage,
    percentCbd,
    percentTac,
    percentThc,
    percentThca,
  } = getPotencyInfo(product, selectedWeight) || {};
  const cbd = formatPotency(percentCbd);
  const tac = formatPotency(percentTac);
  const thc = formatPotency(percentThc);
  const thca = formatPotency(percentThca);

  // Most products will have these properties
  if (cbd || tac || thc || thca) {
    return [
      tac && `TAC ${tac}%`,
      thc && `THC ${thc}%`,
      cbd && `CBD ${cbd}%`,
      thca && `THCa ${thca}%`,
    ]
      .filter(Boolean)
      .join(', ');
  }
  // Edibles & topicals - the format of `dosage` is input by the user & could be anything.
  // Without having `thc_dosage_milligrams` & `cbd_dosage_milligrams` available on other product
  // models we cannot achieve the desired formatting.
  else if (dosage) {
    return compact([dosage, productAmount]).join(' ');
  }

  return '';
};
